import { Route, Redirect, useLocation } from "react-router-dom";
import React, { Component, useEffect, useState } from "react";
import { useAuth } from "../Auth/FAuth";

const PraviteRoute = ({ component: Component, ...rest }) => {
  const { currentUser } = useAuth();
  const [user, setUser] = useState(currentUser);

  return (
    <Route
      {...rest}
      render={(props) =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
            }}
          />
        )
      }
    />
  );
};

export default PraviteRoute;
